import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import IconButton from 'components/common/IconButton';
import Link from 'components/common/Link';
import Avatar from 'components/common/Avatar';
import IconBook from 'components/icons/IconBook';
import IconGear from 'components/icons/IconGear';
import IconLogOut from 'components/icons/IconLogOut';
import IconCloudUpload from 'components/icons/IconCloudUpload';
import Tooltip from 'components/common/Tooltip';
import MobileStepper from '@material-ui/core/MobileStepper';

import AccountLogoutDialog from 'components/account/AccountLogoutDialog';

const styles = theme => ({
  button: {
    marginLeft: 5,
    color: theme.palette.text.primary,
    '&:hover': {
      color: theme.palette.primary[500],
    },
  },
  buttonLogout: {
    marginRight: -5,
  },
  link: {
    display: 'flex',
    color: theme.palette.text.primary,
    marginLeft: 10,
    marginRight: 5,
  },
  typography: {
    maxWidth: 250,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontWeight: 'bold',
  },
  iconBook: {
    width: 23,
    height: 23,
  },
  iconGear: {
    width: 21,
    height: 21,
  },
  iconLogOut: {
    width: 18,
    height: 18,
  },
  iconCloudUpload: {
    width: 25,
    height: 25,
  },
  avatar: {
    width: 40,
    height: 40,
    marginRight: 10,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  storageStepper: {
    width: 300,
    padding: 4,
    display: 'flex',
  },
  typographyStepperLabel: {
    whiteSpace: 'nowrap',
  },
  stepperProgress: {
    width: '100%',
  },
  stepperRoot: {
    width: '100%',
  },
  userInfo: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class DefaultHeaderNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logoutDialogOpen: false,
    };

    this.onLogoutButtonClick = this.onLogoutButtonClick.bind(this);
    this.onLogoutDialogClose = this.onLogoutDialogClose.bind(this);
  }

  onLogoutButtonClick() {
    this.setState({ logoutDialogOpen: true });
  }

  onLogoutDialogClose() {
    this.setState({ logoutDialogOpen: false });
  }

  render() {
    const { account, classes, className, variant } = this.props;
    const { logoutDialogOpen } = this.state;
    let avatarImageSrc;
    if (account.Image && account.Image.length > 0) {
      avatarImageSrc = account.Image;
    }
    return (
      <Toolbar
        disableGutters
        className={className}
      >
        {/*<IconButton
          className={classes.button}
          tooltipColor="white"
          tooltipContent={(
            <div className={classes.storageStepper}>
              <Typography className={classes.typographyStepperLabel}>
                System File Storage:
              </Typography>
              <MobileStepper
                variant="progress"
                steps={100}
                position="static"
                activeStep={20}
                classes={{
                  root: classes.stepperRoot,
                  progress: classes.stepperProgress,
                }}
              />
            </div>
          )}
        >
          <IconCloudUpload className={classes.iconCloudUpload} />
        </IconButton>*/}
{/*        <IconButton
          className={classes.button}
          tooltipContent="Book"
        >
          <IconBook className={classes.iconBook} />
        </IconButton>*/}
        {variant !== 'settings' &&
          <IconButton
            className={classes.button}
            href="/settings"
            tooltipContent="Settings"
            target="_blank"
          >
            <IconGear className={classes.iconGear} />
          </IconButton>
        }
        <Tooltip
          content="My Profile"
          placement="bottom"
          color="dark"
          disableGutters
        >
          <Link
            className={classes.link}
            href="/account/profile"
          >
            <Avatar
              className={classes.avatar}
              src={avatarImageSrc}
            />
            {(account['First Name'] && account['Last Name']) &&
              <div className={classes.userInfo}>
                <Typography
                  className={classes.typography}
                  color="inherit"
                >
                  {`${account['First Name']} ${account['Last Name']}`}
                </Typography>
                {(account.Roles && account.Roles.length > 0) &&
                  <Typography
                    variant="caption"
                    color="inherit"
                  >
                    {account.Roles.map(item => item.Name).join(', ')}
                  </Typography>
                }
              </div>
            }
          </Link>
        </Tooltip>
        <IconButton
          className={classNames(classes.button, classes.buttonLogout)}
          onClick={this.onLogoutButtonClick}
          tooltipContent="Log out"
        >
          <IconLogOut className={classes.iconLogOut} />
        </IconButton>
        <AccountLogoutDialog
          open={logoutDialogOpen}
          onClose={this.onLogoutDialogClose}
        />
      </Toolbar>
    );
  }
}

DefaultHeaderNavigation.propTypes = {
  className: PropTypes.string,
  account: PropTypes.shape({
    Image: PropTypes.string,
    'First Name': PropTypes.string,
    'Last Name': PropTypes.string,
  }).isRequired,
  variant: PropTypes.oneOf(['default', 'settings']),
  classes: PropTypes.shape({
    button: PropTypes.string.isRequired,
    buttonLogout: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
    iconBook: PropTypes.string.isRequired,
    iconGear: PropTypes.string.isRequired,
    iconLogOut: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
  }).isRequired,
};

DefaultHeaderNavigation.defaultProps = {
  className: '',
  variant: 'default',
};

const mapStateToProps = store => ({
  account: store.account,
});

export default connect(mapStateToProps)(
  withStyles(styles)(DefaultHeaderNavigation),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/DefaultHeader/DefaultHeaderNavigation.js